import React, { FC } from 'react';
import { View } from 'react-native';
import { HourlyWeatherHeader } from '@components';

import { styles } from './styles';

type HourlyWeatherTopRowProps = {
  nextFocusDown: unknown;
  defaultFocus: unknown;
};

export const HourlyWeatherTopRow: FC<HourlyWeatherTopRowProps> = ({ nextFocusDown, defaultFocus }) => (
  <View style={styles.topRowWrapper}>
    <View style={styles.rowWrapper}>
      <View style={styles.headerWrapper}>
        <HourlyWeatherHeader defaultFocus={defaultFocus} nextFocusDown={nextFocusDown} />
      </View>
    </View>
  </View>
);
